export default function loader() {
	return import( '@wordpress/latex-to-mathml' );
}
